module.exports = __webpack_public_path__ + "img/SwissTrust3.1b3e1fac.png";